interface CustomLoadingModalProps {
  isOpen?: boolean;
  loadingText?: string;
  spinnerSize?: number;
  overlayOpacity?: string;
  className?: string;
}

const CustomLoadingModal = ({
  isOpen = true,
  loadingText = "Loading, please wait...",
  spinnerSize = 48,
  overlayOpacity = "50",
  className = "",
}: CustomLoadingModalProps) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-${overlayOpacity} 
                  flex items-center justify-center z-50`}
    >
      <div className={`flex flex-col items-center text-white ${className}`}>
        <div
          className={`border-4 border-t-transparent border-brand-orange 
                      rounded-full animate-spin`}
          style={{ width: spinnerSize, height: spinnerSize }}
        ></div>

        <p className="mt-3 text-sm font-openSans text-center">{loadingText}</p>
      </div>
    </div>
  );
};

export default CustomLoadingModal;
